import getDatePickerButtons from 'core/utils/get-date-picker-buttons';
import { CALENDAR, RANGE, PERIOD } from 'lib/calendar/constants';

export const buildCalLookupPayload = (state) => {
  const defaultPayload = {
    calendarType: state.calendarType,
    dateType: state.dateType,
    rangeType: state.rangeType,
    number: state.number,
    clientId: state.clientId,
  };
  if (state.rangeType === 'C') {
    return {
      ...defaultPayload,
      first: state.first,
      last: state.last,
    };
  }
  return defaultPayload;
};

//the input we have for daterange in graphql only accept 'G' not 'GREGORIAN'
//does be accept both?
//TODO: align types of graphql and be
export const translateToShortDateRange = (payload) => ({
  c: CALENDAR[payload.c] || payload.c,
  r: RANGE[payload.r] || payload.r,
  p: PERIOD[payload.p] || payload.p,
  n: payload.n,
  k: payload.k,
  t: payload.t,
  a: payload.a,
  f: payload.f,
  l: payload.l,
});

// we use moment date in old app, lets convert it to string here
export const convertMomentToString = (date) => {
  if (date && date?.isValid?.()) {
    return date.format('YYYY-MM-DD');
  }
  return date;
};

export const getSelectedDatePickerOption = (dateRange, dateOption) => {
  let datePickerOptions = dateOption;
  if (!datePickerOptions) {
    datePickerOptions = getDatePickerButtons(dateRange?.t || 'DATE_ONLY');
  }

  const abbRangeType = RANGE[dateRange.r] || dateRange.r;

  if (abbRangeType === 'C') return datePickerOptions[0];

  return datePickerOptions.find(
    (o) => o.rangeType === abbRangeType && o.number === dateRange.n
  );
};
